import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import data from '../../../config/producttype.json';
import { makeStyles } from '@mui/styles';
import ProductDescription from '../../signup/product/ProductDescription';
import { productsCanBeOpened } from '../../../utils/function/Function';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../../redux/create-actions/AlertAction';
import { initStep0Data } from '../../../utils/object/OpenContract';
import { useTheme } from '@mui/material';
import { closeLoadingApi, openLoadingApi } from '../../../redux/create-actions/LoadingAction';
import Color from '../../../layouts/Color';
import Typography from '@mui/material/Typography';
import { graphGetAllContractByCustomer } from '../../../services/Contract';
import { graphGetAllProducts } from '../../../services/Onboarding';
import { ProductCardType } from '../../../enum/Enum.ts';

const useStyles = makeStyles(function (theme) {
  return {
    gridContainer: {
      [theme.breakpoints.up("xl")]: {
        paddingLeft: ' 200px',
        paddingRight: '200px',
        marginTop: "20px"
      },
    },
  };
});

const info = { textAlign: 'left' };
const groupRadio = { alignSelf: 'flex-start', marginTop: 1 };
const minStyle = { minWidth: 120 }

export default function Product(props) {
  const theme = useTheme();
  const classes = useStyles();
  const [productType, setProductType] = useState(ProductCardType.PREPAID);
  const [product, setProduct] = useState('');
  const [listProducts, setListProducts] = useState([]);
  const [filterProducts, setFilterProducts] = useState([]);
  const dispatch = useDispatch();
  const [contracts, setContracts] = useState(null);

  useEffect(() => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: ''
    };
    dispatch(openLoadingApi());
    const promise = graphGetAllContractByCustomer();
    promise.then((result) => {
        setContracts(result.items);
        dispatch(closeLoadingApi());
    }).catch(error => {
      alert = { ...alert, message: error };
      dispatch(showAlert(alert));
      dispatch(closeLoadingApi());
    })
  }, [dispatch]);

  const productsIsNotAllowedToOpen = () => {
    var list = [];
    for (const contract of contracts) {
      list.push(contract.product.productCode);
    }
    return list;
  }

  useEffect(() => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    if (contracts !== null) {
      dispatch(openLoadingApi());

      const variables = {
        "filter": {
          "isDelete": 0
        },
        "options": {
          "fetchAll": true
        }
      }
      let promise = graphGetAllProducts(variables);
      promise.then(result => {
          let products = result.items;
          let list = productsCanBeOpened(products, ProductCardType.PREPAID, productsIsNotAllowedToOpen());
          setListProducts(products);
          setFilterProducts(list);
          dispatch(closeLoadingApi());
      }).catch(function (error) {
        alert = { ...alert, message: error };
        dispatch(closeLoadingApi());
        dispatch(showAlert(alert));
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, contracts]);

  const filterProductByProductCode = (code) => {
    return filterProducts.filter(product => product.productCode === code);
  }

  const handleChangeProduct = (event) => {
    let value = event.target.value;
    setProduct(value);
    let currentProduct = filterProductByProductCode(value);
    props.onUpdateStep0Data(initStep0Data(productType, value, currentProduct[0].name));
  };

  const renderProductOption = filterProducts.map((item, i) => {
    return (
      <MenuItem value={item.productCode} key={i}>{item.name}</MenuItem>
    );
  });

  const renderProductType = data.types.map((item, i) => {
    return (
      <FormControlLabel value={item.value === 1 ? ProductCardType.PREPAID : ProductCardType.CREDIT} control={<Radio />} label={item.label} key={i} />
    );
  });

  const handleChangeProductType = (event) => {
    let value = event.target.value;
    let list;
    switch (value) {
      case ProductCardType.PREPAID:
        list = productsCanBeOpened(listProducts, ProductCardType.PREPAID, productsIsNotAllowedToOpen());
        break;
      case ProductCardType.CREDIT:
        list = productsCanBeOpened(listProducts, ProductCardType.CREDIT, productsIsNotAllowedToOpen());
        break;
      default:
        list = [];
        break;
    }
    setProductType(value);
    setFilterProducts(list);
    setProduct('');
  }

  return (
    <React.Fragment>
      <Grid container spacing={3} className={classes.gridContainer}>
        <Grid item xs={12}>
          <Grid item xs={12} sx={info}> 
            <Typography variant="h4" color={Color.Main}> Please select product type and product: </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormLabel id="demo-row-radio-buttons-group-label" sx={groupRadio}>Product Type:</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={productType}
                onChange={handleChangeProductType}
              >
                {renderProductType}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl sx={minStyle} fullWidth>
            <InputLabel id="demo-simple-select-helper-label">Product *</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={product}
              label="Product"
              onChange={handleChangeProduct}
              sx={{
                '& .MuiInputBase-input': {
                  bgcolor: theme.palette.background.default
                },
                bgcolor: theme.palette.background.default,
              }}
            >
              {renderProductOption}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <ProductDescription selectedProduct={product}></ProductDescription>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}